
import React from 'react';

const CTA: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-4xl font-bold mb-6">
              Choose Zoho One. Accelerate business growth.
            </h2>
            <button className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer mb-6">
              Activate Free Trial
            </button>
            
            <ul className="space-y-2 text-blue-100">
              <li className="flex items-center">
                <i className="ri-check-line mr-2"></i>
                Free for 30 days
              </li>
              <li className="flex items-center">
                <i className="ri-check-line mr-2"></i>
                No card details required
              </li>
              <li className="flex items-center">
                <i className="ri-check-line mr-2"></i>
                Free support and training
              </li>
            </ul>
          </div>
          
          <div className="flex justify-center">
            <img 
              src="https://www.zohowebstatic.com/sites/zweb/images/one/home/bottom-img.png"
              alt="Choose Zoho One"
              className="w-full max-w-md h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
